/**
 * Plumelle analytics helpers — GA4 via GTM dataLayer + Clarity custom events.
 * Events:
 *   plumelle_sticky_atc_click / plumelle_sticky_atc_success
 *   plumelle_cart_pillowcase_upsell_click / plumelle_cart_pillowcase_upsell_success
 */
(function () {
  if (window.__plumelleTrackReady) return;
  window.__plumelleTrackReady = true;

  const EVENTS = {
    stickyClick: 'plumelle_sticky_atc_click',
    stickySuccess: 'plumelle_sticky_atc_success',
    pillowcaseClick: 'plumelle_cart_pillowcase_upsell_click',
    pillowcaseSuccess: 'plumelle_cart_pillowcase_upsell_success',
  };

  function plumelleTrack(eventName, params) {
    if (!eventName) return;

    const payload = Object.assign({ event: eventName }, params || {});

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) {
      /* ignore */
    }

    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        if (params && params.source) {
          window.clarity('set', 'plumelle_last_cta', String(params.source));
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  window.plumelleTrack = plumelleTrack;

  function formFromSubmit(button) {
    if (!button) return null;
    if (button.form) return button.form;
    return button.closest('form');
  }

  function readFormPayload(form, source) {
    const payload = { source: source };
    if (!form) return payload;

    const idInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const variantId = idInput?.value;

    if (variantId) {
      payload.item_id = String(variantId);
      payload.item_variant = String(variantId);
    }

    if (qtyInput?.value) {
      const qty = Number(qtyInput.value);
      if (!Number.isNaN(qty) && qty > 0) payload.quantity = qty;
    }

    const stickyBar = form.closest('.plumelle-sticky-atc');
    if (stickyBar) {
      const title = stickyBar.querySelector('.plumelle-sticky-atc__title')?.textContent?.trim();
      if (title) payload.item_name = title;
    }

    const completeSet = form.closest('.cart-complete-set, cart-complete-set-upsell');
    if (completeSet) {
      const title = completeSet.querySelector('.cart-item__name')?.textContent?.trim();
      if (title) payload.item_name = title;
      const size = completeSet.querySelector('[data-complete-set-size-label]')?.textContent?.trim();
      if (size) payload.item_size = size;
      const color = completeSet.querySelector('.cart-complete-set__color-col dd')?.textContent?.trim();
      if (color) payload.item_color = color;
    }

    return payload;
  }

  function isStickySubmit(el) {
    return Boolean(el?.closest?.('.plumelle-sticky-atc') && el.matches('button[type="submit"], .plumelle-sticky-atc__submit'));
  }

  function isPillowcaseSubmit(el) {
    return Boolean(
      el?.closest?.('.cart-complete-set, cart-complete-set-upsell') &&
        (el.matches('[data-complete-set-submit], .cart-complete-set__submit') ||
          (el.matches('button[type="submit"]') && el.closest('.cart-complete-set')))
    );
  }

  function onClickCapture(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('button[type="submit"], [type="submit"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    if (isStickySubmit(button)) {
      const form = formFromSubmit(button);
      plumelleTrack(EVENTS.stickyClick, readFormPayload(form, 'sticky_atc'));
      return;
    }

    if (isPillowcaseSubmit(button)) {
      const form = formFromSubmit(button);
      plumelleTrack(EVENTS.pillowcaseClick, readFormPayload(form, 'cart_pillowcase_upsell'));
    }
  }

  function onVariantAdd(event) {
    const detail = event.detail || {};
    const form = detail.formElement;
    if (!form) return;

    const quantity = Number(detail.quantity || form.querySelector('[name="quantity"]')?.value || 1);
    const variantId = detail.variant?.id || form.querySelector('[name="id"]')?.value;

    if (form.closest('.plumelle-sticky-atc')) {
      const payload = readFormPayload(form, 'sticky_atc');
      if (variantId) {
        payload.item_id = String(variantId);
        payload.item_variant = String(variantId);
      }
      if (quantity > 0) payload.quantity = quantity;
      plumelleTrack(EVENTS.stickySuccess, payload);
      return;
    }

    if (form.closest('.cart-complete-set, cart-complete-set-upsell')) {
      const payload = readFormPayload(form, 'cart_pillowcase_upsell');
      if (variantId) {
        payload.item_id = String(variantId);
        payload.item_variant = String(variantId);
      }
      if (quantity > 0) payload.quantity = quantity;
      plumelleTrack(EVENTS.pillowcaseSuccess, payload);
    }
  }

  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('variant:add', onVariantAdd);
})();
